import { EventEmitter, Injectable } from '@angular/core';

export interface GuidanceContext {
    resource: string;
    width?: string;
}

@Injectable({
    providedIn: 'root',
})
export class GuidanceService {
    public lookingFor: EventEmitter<GuidanceContext> =
        new EventEmitter<GuidanceContext>();

    public constructor() {}

    public contextualize(context: GuidanceContext): void {
        this.lookingFor.emit(context);
    }
}
